<template>
    <div class="test-service-detail">
        <a-breadcrumb separator=">">
            <a-breadcrumb-item
                ><router-link to="/test-service"
                    ><img
                        src="../../assets/test-service/service.svg"
                        style="margin: 0 4px 4px 0"
                    />检测服务</router-link
                ></a-breadcrumb-item
            >
            <a-breadcrumb-item>详情</a-breadcrumb-item>
        </a-breadcrumb>
        <div class="flow">
            <custom-form
                ref="info-form"
                :panels="panelFields"
                :hideFields="hideFields"
                :fieldsValue="orderFormData"
                :readonly="true"
                @change="changeHandle"
                layout="vertical"
                style="margin-bottom: 26px"
            ></custom-form>

            <div class="test-project">
                <div class="label">请选择检测项目类型</div>
                <a-checkbox-group disabled v-model="checkedProj" style="width: 100%">
                    <a-row :gutter="[32, 8]" v-for="(st, index) of groupSelectTests" :key="index">
                        <a-col :span="6" v-for="test of st" :key="test.id">
                            <a-checkbox :value="test"> {{ test.testName }}</a-checkbox>
                        </a-col>
                    </a-row>
                </a-checkbox-group>
                <div class="count">已检测项目({{ checkedProj.length }})</div>
            </div>

            <div class="title">样品列表</div>
            <a-table
                :columns="columns"
                :data-source="sampleData.rows"
                rowKey="id"
                :scroll="{ y: 320, x: 1000 }"
                :pagination="pagination"
                :loading="loading"
                @change="handleTableChange"
            >
                <template #sampleCountUnit="record">
                    <div>{{ getUnitName(record.sampleCountUnit) }}</div>
                </template>
                <template #action="record">
                    <a style="display: block" @click="openDetail(record)">详情</a>
                    <a style="display: block">物流信息</a>
                </template>
            </a-table>

            <a-modal
                :visible="visible"
                destroyOnClose
                title="样品详情"
                :footer="null"
                class="add-sample"
                width="80%"
                :dialogStyle="{
                    height: '80%'
                }"
                @cancel="handleCancel"
            >
                <custom-form
                    ref="add-form"
                    :panels="sampleFields"
                    :readonly="true"
                    :hideFields="selectOrderHideFields"
                    :fieldsValue="sampleInfo"
                    layout="vertical"
                ></custom-form>
                <custom-form
                    ref="other-form"
                    :readonly="true"
                    :fieldsValue="otherInfo"
                    :panels="otherFields"
                    layout="vertical"
                ></custom-form>
            </a-modal>

            <div class="button-contain">
                <a-button @click="cancel">取消</a-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex';
import customForm from '../../components/custom-form.vue';
export default {
    components: { customForm },
    data() {
        return {
            loading: false,
            params: {
                type: 'detail',
                systemType: 'LIMS',
                orderCodeFlag: 'draft',
                viewTaskBtn: '1',
                pushToLimsFlag: '0',
                folderId: this.$route.query.folderId
            },
            checkedProj: [],
            current: 0,
            currentPage: 1,
            pageSize: 10,
            sampleType: '',
            columns: [
                { title: '样品', dataIndex: 'id', align: 'center' },
                { title: '样品编号', dataIndex: 'orderCode', align: 'center' },
                { title: '样品名称', dataIndex: 'mtlName', align: 'center' },
                { title: '样品数量', dataIndex: 'sampleCount', align: 'center' },
                {
                    title: '单位',
                    key: 'sampleCountUnit',
                    align: 'center',
                    scopedSlots: { customRender: 'sampleCountUnit' }
                },
                { title: '生产企业', dataIndex: 'dimensionGeneratingUnit', align: 'center' },
                { title: '其他技术指标或原编号', dataIndex: 'originalNumber', align: 'center' },
                { title: '备注信息', dataIndex: 'remark', align: 'center' },
                { title: '样品状态', dataIndex: 'status', align: 'center' },
                {
                    title: '操作',
                    key: 'operation',
                    fixed: 'right',
                    width: 100,
                    scopedSlots: { customRender: 'action' }
                }
            ],

            visible: false,
            sampleInfo: {}, //样品信息
            otherInfo: {} //其他参数信息
        };
    },

    async created() {
        this.setSampleType(this.isCigarette);
        await this.getOrderFormData(this.params.folderId);
        await this.getFolderTask(this.params.folderId);
        const orderTmplId = (
            await this.getOrderTemp({
                f: {
                    sampleTypeCode_SEQ: this.orderFormData.sampleType,
                    folderId: this.params.folderId,
                    defaultProcess_SEQ: '1'
                },
                n: -1
            })
        ).data.rows[0]?.id;

        await this.getSelectTests({
            f: { orderTmplId, enable_SEQ: '1' },
            n: -1,
            o: [{ 'ext$.itemclassificationid': 'asc' }, { itemclassificationname: 'asc' }]
        });

        this.checkedProj = this.selectTests.filter(s => {
            return this.folderTask.map(f => f.testId).includes(s.id.toString());
        });

        await this.getSampleData({
            folderId: this.params.folderId,
            f: { longRangeStandard_DIFFER: '1' },
            n: this.currentPage,
            s: this.pageSize,
            qf: {},
            o: [{ orderNo: 'desc' }]
        });

        this.sampleType = this.orderFormData.sampleType;
        //单位下拉参数
        await this.getQSampleType({ f: { SCATEGORYCODE_SEQ: this.sampleType } });

        if (this.orderFormData.sampleType) {
            this.getSampleUnit(this.orderFormData.sampleType);
        }
    },
    watch: {
        originSampleType: {
            immediate: true,
            handler() {
                this.setSampleType(this.isCigarette);
            }
        }
    },

    computed: {
        ...mapState('testService', [
            'hideFields',
            'orderFormData',
            'selectTests',
            'sampleData',
            'virtualId',
            'selectOrderHideFields',
            'folderTask'
        ]),
        ...mapState('testService', { unitSelect: state => state.sampleType }),
        ...mapGetters('testService', ['panelFields', 'sampleFields', 'otherFields']),
        ...mapState(['originSampleType']),

        pagination() {
            return {
                total: this.sampleData.total ?? 0,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: this.pageSize,
                showTotal(total) {
                    return `总共${total}条`;
                },
                current: this.currentPage
            };
        },

        dateFields() {
            const arr = [];
            this.panelFields.forEach(panel => {
                const fields = panel.fieldGroup[0];
                const df = fields.filter(f => f.type === 'date');
                arr.concat(df);
            });
            return arr;
        },

        groupSelectTests() {
            const selectTests = this.selectTests;
            return this.chunkArray(selectTests, 4);
        },

        isCigarette() {
            return this.$route.meta.isCigarette;
        }
    },

    methods: {
        ...mapActions('testService', [
            'getOrderFormData',
            'getSelectTests',
            'getOrderTemp',
            'insertOrderTask',
            'getSampleData',
            'getNextIdentity',
            'getQSampleType',
            'insertOrderLims',
            'saveOrderFormData',
            'getSelectParameterFields',
            'getSelectOrderHideFields',
            'submitToLims',
            'getFolderTask'
        ]),
        ...mapActions(['getSampleUnit']),
        ...mapMutations(['changeSpinning', 'setSampleType']),
        cancel() {
            this.$router.push({ name: this.isCigarette ? 'cigarette-entrust' : 'test-service' });
        },

        viewDetail() {
            this.$router.push({ name: 'test-service' });
        },

        getUnitName(val) {
            if (val) {
                const data = this.unitSelect.find(item => item.value === val);
                if (data.label) {
                    return data.label;
                } else {
                    return val;
                }
            }
        },

        async insertOrderType() {
            this.loading = true;
            const checkedProj = this.checkedProj;
            const chooseData = checkedProj.map(item => {
                return {
                    testId: item.id,
                    testName: item.testName,
                    testMethodId: item.ext$.testmethodid,
                    postId: item.ext$.postid,
                    projectTemplateGroupId: item.ext$.projecttemplategroupid,
                    postName: item.ext$.postname,
                    methodCodes: item.ext$.methodcodes,
                    itemClassificationId: item.ext$.itemclassificationid,
                    classficationFullName: item.ext$.itemclassificationname,
                    cost: item.cost,
                    ext$: {
                        testmethodpostid: item.ext$.testmethodpostid,
                        projectapproval: item.projectApproval,
                        postnames: item.ext$.postnames
                    },
                    folderId: this.params.folderId
                };
            });

            await this.insertOrderTask(chooseData);
            this.loading = false;
            this.nextStep();
        },

        nextStep() {
            this.current++;
        },

        prevStep() {
            this.current--;
        },

        chunkArray(arr, chunkSize) {
            const chunkedArray = [];
            for (let i = 0; i < arr.length; i += chunkSize) {
                chunkedArray.push(arr.slice(i, i + chunkSize));
            }
            return chunkedArray;
        },

        async handleTableChange(pagination) {
            this.currentPage = pagination.current;
            this.pageSize = pagination.pageSize;
            this.loading = true;
            await this.getSampleData({
                f: { longRangeStandard_DIFFER: '1' },
                n: this.currentPage,
                s: this.pageSize,
                qf: {},
                o: [{ orderNo: 'desc' }]
            });
            this.loading = false;
        },

        async openDetail(val) {
            await this.getSelectOrderHideFields();
            this.changeSpinning(true);
            this.loading = true;
            await this.getNextIdentity();
            await this.getSelectParameterFields(this.sampleType);
            this.visible = true;
            this.changeSpinning(false);
            this.loading = false;

            setTimeout(() => {
                this.sampleInfo = { ...val };
                this.otherInfo = { ...val.ext$ };
            }, 0);
        },

        handleOk() {
            this.changeSpinning(true);
            const form = this.$refs['add-form'].form;
            const otherForm = this.$refs['other-form'].form;
            form.validateFields(async (err, values) => {
                if (!err) {
                    const p = {
                        p: {
                            type:
                                this.params.long_range_flag === 'long_range_flag'
                                    ? this.params.long_range_flag
                                    : 'limsOrdersAdd',
                            province: this.params.province,
                            industrytaskOrderId: this.params.industrytaskOrderId,
                            virtualId: this.virtualId,
                            addFrom: this.params.addFrom,
                            modify: this.params.modify
                        },
                        b: ['limsOrderServiceImpl', [{ folderId: this.params.folderId, ...values }]],
                        b1: ['limsOrdersParamServiceImpl', [otherForm.getFieldsValue()]]
                    };

                    await this.insertOrderLims(p);

                    this.getSampleData({
                        folderId: this.params.folderId,
                        f: { longRangeStandard_DIFFER: '1' },
                        n: this.currentPage,
                        s: this.pageSize,
                        qf: {},
                        o: [{ orderNo: 'desc' }]
                    });
                    this.visible = false;
                } else {
                    this.$warning({
                        title: '校验失败',
                        content: '请检查是否存在检验失败的字段'
                    });
                }

                this.changeSpinning(false);
            });
        },

        handleCancel() {
            this.visible = false;
        },

        async submit() {
            this.loading = true;
            await this.submitToLims({
                b: ['', [{ id: this.params.folderId, systemType: 'LIMS', ext$: { sampletype: this.sampleType } }]]
            });

            this.loading = false;
            this.nextStep();
        },

        changeHandle(...args) {
            if (args[0] === 'sampleType') {
                this.getSampleUnit(args[1]);
                this.$refs['info-form'].form.setFieldsValue({
                    sampleUnit: undefined
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.test-service-detail {
    width: 1200px;

    ::v-deep {
        .ant-form {
            .panel {
                margin-bottom: 16px;
                .rows {
                    padding: 16px 16px 0 16px;
                    border: 1px solid rgba(235, 235, 235, 1);
                }
            }

            .ant-form-item-label {
                line-height: 25px;
            }
        }
    }

    .flow {
        background: #ffffff;
        border-radius: 4px;
        padding: 16px;
        min-height: 500px;

        .ant-steps {
            width: 750px;
            margin: 8px 0 40px 0;
            position: relative;
            left: 50%;
            transform: translateX(-50%);
        }

        .button-contain {
            display: flex;
            align-items: center;
            justify-content: center;
            .ant-btn {
                width: 200px;
                height: 44px;
                margin: 8px;
            }
        }

        .test-project {
            background: rgba(222, 233, 244, 0.2);
            border-radius: 2px;
            padding: 16px 24px;
            position: relative;
            left: 50%;
            transform: translateX(-50%);

            .label {
                width: 100%;
                height: 32px;
                font-size: 14px;
                color: #333333;
                letter-spacing: 0;
                font-weight: 600;
            }

            .count {
                font-size: 14px;
                color: #333333;
                letter-spacing: 0;
                font-weight: 600;
                border-top: 1px solid #eee;
                padding-top: 8px;
            }

            ::v-deep {
                .ant-checkbox-group {
                    .ant-checkbox-wrapper {
                        display: flex;

                        .ant-checkbox {
                            position: relative;
                            top: 3px;

                            &.ant-checkbox-checked:hover {
                                height: 16px;
                            }
                        }
                    }

                    .ant-checkbox-disabled+span{
                        color: rgba(0, 0, 0);
                    }
                    .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner:after{
                        border-color: #1890ff;
                    }
                }
            }
        }

        .title {
            width: 100%;
            height: 40px;
            line-height: 40px;
            text-align: left;
            font-size: 14px;
            color: #333333;
            letter-spacing: 0;
            font-weight: 600;
        }

        .toolbar {
            width: 100%;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            .ant-btn {
                margin: 0 4px;
            }
        }

        .result {
            display: flex;
            flex-direction: column;
            align-items: center;
        }
    }
}
::v-deep.add-sample {
    .ant-modal {
        color: red;
        .ant-modal-content {
            display: flex;
            flex-direction: column;
            height: 100%;
            .ant-modal-body {
                flex: 1;
                overflow-y: auto;
            }
        }
    }
}
</style>
